/**
 * 🗺️ FIRESTORE PATHS (Single Source of Truth)
 * Centralizes all collection and document paths to ensure consistency
 * between Client SDK and Admin SDK.
 */
export const FirestorePaths = {
  // Global / Root Collections
  tasaDoc: 'tasa/tasa',
  globalPaymentMethods: 'global/payment-methods',
  landingMetrics: 'global/metrics',
  legalVersions: 'global/legal/versions',
  legalAcceptances: 'legal_acceptances',
  globalAdmin: 'global/admin',
  
  // Independent Resource Collections (Root Level)
  slugs: 'slugs',
  slugDoc: (slug: string) => `slugs/${slug}`,
  
  public: 'public',
  publicDoc: (ownerId: string) => `public/${ownerId}`,
  
  appointments: 'appointments',
  appointmentDoc: (id: string) => `appointments/${id}`,
  
  sales: 'sales',
  saleDoc: (id: string) => `sales/${id}`,
  
  services: 'services',
  serviceDoc: (id: string) => `services/${id}`,
  
  // Businesses (Formerly Owners) & Sub-collections
  businesses: 'businesses',
  businessDoc: (businessId: string) => `businesses/${businessId}`,
  


  // --- NESTED RESOURCES (Privacy & Structure) ---
  employees: (businessId: string) => `businesses/${businessId}/employees`,
  employeeDoc: (businessId: string, employeeId: string) => `businesses/${businessId}/employees/${employeeId}`,
  
  payroll_cycles: (businessId: string) => `businesses/${businessId}/payroll_cycles`,
  payrollCycleDoc: (businessId: string, cycleId: string) => `businesses/${businessId}/payroll_cycles/${cycleId}`,

  transactions: (businessId: string) => `businesses/${businessId}/transactions`,
  transactionDoc: (businessId: string, txId: string) => `businesses/${businessId}/transactions/${txId}`,
  
  balances: (businessId: string) => `businesses/${businessId}/balances`,
  balanceDoc: (businessId: string, workerId: string) => `businesses/${businessId}/balances/${workerId}`,
  
  settlements: (businessId: string) => `businesses/${businessId}/settlements`,
  settlementDoc: (businessId: string, settlementId: string) => `businesses/${businessId}/settlements/${settlementId}`,
  
  expenses: (businessId: string) => `businesses/${businessId}/expenses`,
  expenseDoc: (businessId: string, expenseId: string) => `businesses/${businessId}/expenses/${expenseId}`,
  
  products: (businessId: string) => `businesses/${businessId}/products`,
  productDoc: (businessId: string, productId: string) => `businesses/${businessId}/products/${productId}`,
  
  loans: (businessId: string) => `businesses/${businessId}/loans`,
  loanDoc: (businessId: string, loanId: string) => `businesses/${businessId}/loans/${loanId}`,
  
  // Admin / Private Sub-collections
  marketingConfig: (businessId: string) => `businesses/${businessId}/admin/marketing`,
  adminSettings: (businessId: string) => `businesses/${businessId}/admin/settings`,
  adminPrivate: (businessId: string) => `businesses/${businessId}/admin/private`,
  adminBilling: (businessId: string) => `businesses/${businessId}/admin/billing/records`,
  
  // --- MARKETING & AI ---
  marketingThreads: (businessId: string) => `businesses/${businessId}/marketing_threads`,
  marketingThreadDoc: (businessId: string, phone: string) => `businesses/${businessId}/marketing_threads/${phone}`,
  marketingThreadMessages: (businessId: string, phone: string) => `businesses/${businessId}/marketing_threads/${phone}/messages`,
};

